import React, { useState, useEffect } from 'react';
import { RiArrowLeftSLine, RiArrowRightSLine } from 'react-icons/ri';
import { FaChartBar, FaFilePdf, FaMobileAlt } from 'react-icons/fa';

import image1 from '../../image/phone1.png';
import image2 from '../../image/phone2.png';
import image3 from '../../image/phone3.png';
import image4 from '../../image/phone4.png';
import image5 from '../../image/phone5.png';

const screenshots = [
  { src: image1, label: 'Tableau de bord', desc: 'Vue d\'ensemble de vos finances en temps réel.' },
  { src: image2, label: 'Ajout de transaction', desc: 'Enregistrez vos revenus et dépenses en quelques secondes.' },
  { src: image3, label: 'Résumé mensuel', desc: 'Visualisez vos performances financières en un coup d\'œil.' },
  { src: image4, label: 'Gestion des dossiers', desc: 'Organisez vos entreprises et clients facilement.' },
  { src: image5, label: 'Rapports', desc: 'Générez des documents professionnels pour vos déclarations.' },
];

const miniCards = [
  { icon: FaMobileAlt, title: 'Ajout de transaction', desc: 'Saisie rapide depuis votre smartphone.' },
  { icon: FaChartBar, title: 'Résumé mensuel', desc: 'Performances financières en un coup d\'œil.' },
  { icon: FaFilePdf, title: 'Rapport PDF', desc: 'Documents professionnels générés automatiquement.' },
];

const AppScreenshots = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % screenshots.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const current = screenshots[currentIndex];

  return (
    <section className="lp-section lp-showcase">
      <div className="lp-container">
        <header className="lp-section-header lp-reveal">
          <div className="lp-badge">
            <span className="lp-badge-dot" />
            Application mobile
          </div>
          <h2 className="lp-title">
            Découvrez <span className="lp-title-accent">Easy Compta</span>
          </h2>
          <p className="lp-subtitle lp-subtitle-center">
            Explorez les fonctionnalités qui simplifient la gestion financière
            des entrepreneurs sénégalais
          </p>
        </header>

        <div className="lp-showcase-panel lp-reveal">
          <div className="lp-showcase-grid">
            <div className="lp-showcase-content">
              <p style={{ fontSize: '0.8rem', opacity: 0.8, marginBottom: 8, textTransform: 'uppercase' }}>
                {currentIndex + 1} / {screenshots.length}
              </p>
              <h3>{current.label}</h3>
              <p>{current.desc}</p>

              <div className="lp-carousel-nav">
                <button
                  type="button"
                  className="lp-carousel-btn"
                  onClick={() =>
                    setCurrentIndex((prev) => (prev - 1 + screenshots.length) % screenshots.length)
                  }
                  aria-label="Image précédente"
                >
                  <RiArrowLeftSLine size={22} />
                </button>
                <button
                  type="button"
                  className="lp-carousel-btn"
                  onClick={() =>
                    setCurrentIndex((prev) => (prev + 1) % screenshots.length)
                  }
                  aria-label="Image suivante"
                >
                  <RiArrowRightSLine size={22} />
                </button>
                <div className="lp-carousel-dots">
                  {screenshots.map((_, index) => (
                    <button
                      key={index}
                      type="button"
                      className={`lp-carousel-dot ${index === currentIndex ? 'active' : ''}`}
                      onClick={() => setCurrentIndex(index)}
                      aria-label={`Voir capture ${index + 1}`}
                    />
                  ))}
                </div>
              </div>
            </div>

            <div className="lp-showcase-image">
              <img key={current.src} src={current.src} alt={current.label} />
            </div>
          </div>
        </div>

        <div className="lp-showcase-cards">
          {miniCards.map((card) => {
            const Icon = card.icon;
            return (
              <div key={card.title} className="lp-showcase-mini lp-reveal">
                <Icon className="lp-showcase-mini-icon" />
                <div>
                  <h4>{card.title}</h4>
                  <p>{card.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AppScreenshots;
